
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Shield } from 'lucide-react';
import { HomeTemplate } from '@/components/templates/HomeTemplates';

// Simplified unauthorized page since all users now have all permissions
const Unauthorized: React.FC = () => {
  return (
    <HomeTemplate>
      <div className="min-h-screen flex items-center justify-center px-4 py-12">
        <div className="max-w-md w-full space-y-8 bg-white p-6 rounded-lg shadow-lg">
          <div className="text-center">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
              <Shield className="h-8 w-8 text-green-600" />
            </div>
            <h2 className="mt-6 text-3xl font-bold text-gray-900">גישה מאושרת</h2>
            <p className="mt-2 text-sm text-gray-600">
              כל המשתמשים במערכת יכולים לגשת לכל התכונות והדפים.
            </p>
          </div>
          
          <div className="flex flex-col space-y-3">
            <Button asChild variant="default">
              <Link to="/dashboard">חזרה ללוח הבקרה</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/">חזרה לדף הבית</Link>
            </Button>
          </div>
        </div>
      </div>
    </HomeTemplate>
  );
};

export default Unauthorized;
